export default function ComponentInfo({ block }) {
  if (!block) return null;

  const renderValue = (value) => {
    // Handle HTML content specially
    if (typeof value === 'string' && value.includes('<')) {
      return (
        <div style={{ marginLeft: '16px', marginTop: '8px' }}>
          <details>
            <summary
              style={{
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '.8rem',
                userSelect: 'none',
              }}
            >
              Show HTML Content
            </summary>
            <pre
              style={{
                backgroundColor: '#f5f5f5',
                padding: '8px',
                overflow: 'auto',
                fontSize: '.7rem',
              }}
            >
              {value}
            </pre>
          </details>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="container componentInfo"
      style={{
        backgroundColor: '#fff',
        paddingTop: 'var(--space-2xl)',
        paddingBottom: 'var(--space-m)',
      }}
    >
      <div
        style={{
          border: '1px solid #000',
          padding: '20px',
          maxWidth: '800px',
        }}
      >
        <h4 style={{ textTransform: 'uppercase' }}>{block.type}</h4>

        {Object.entries(block).map(([key, value]) => (
          <div key={key} style={{ marginTop: '4px' }}>
            <strong>{key}:</strong>

            {Array.isArray(value) ? (
              <div style={{ marginLeft: '16px', marginTop: '8px' }}>
                {value.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      border: '1px solid #ddd',
                      padding: '12px',
                      marginBottom: '8px',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    {typeof item === 'object' && item !== null
                      ? Object.entries(item).map(([itemKey, itemValue]) => {
                          const specialRender = renderValue(itemValue);
                          return (
                            <div key={itemKey} style={{ marginBottom: '4px' }}>
                              <strong style={{ fontSize: '0.9em' }}>
                                {itemKey}:
                              </strong>
                              {specialRender ? (
                                specialRender
                              ) : (
                                <span style={{ wordBreak: 'break-word' }}>
                                  {typeof itemValue === 'object'
                                    ? JSON.stringify(itemValue, null, 2)
                                    : String(itemValue)}
                                </span>
                              )}
                            </div>
                          );
                        })
                      : String(item)}
                  </div>
                ))}
              </div>
            ) : typeof value === 'string' ? (
              renderValue(value) || (
                <span style={{ marginLeft: '8px' }}>{String(value)}</span>
              )
            ) : typeof value === 'object' && value !== null ? (
              renderValue(value) || (
                <div style={{ marginLeft: '16px', marginTop: '8px' }}>
                  <pre
                    style={{
                      backgroundColor: '#f5f5f5',
                      padding: '8px',
                      overflow: 'auto',
                      fontSize: '.8rem',
                    }}
                  >
                    {JSON.stringify(value, null, 2)}
                  </pre>
                </div>
              )
            ) : (
              <span style={{ marginLeft: '8px' }}>{String(value)}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
